import axios, { AxiosError } from 'axios';

let instance: ApiService = null;

export default class ApiService {
    api = process.env.VUE_APP_API_URL || 'http://vrapi.test/v1/';

    constructor() {
        if (!instance) {
            this.reset();
        }

        axios.defaults.headers.Authorization = `Bearer ${this.token}`;

        return instance;
    }

    reset() {
        instance = this;
    }

    get token() {
        return window.localStorage.getItem('auth.token');
    }

    set token(token: string) {
        window.localStorage.setItem('auth.token', token);
        axios.defaults.headers.Authorization = `Bearer ${this.token}`;
    }

    get(path: string) {
        return axios
            .get(`${this.api}${path}`)
            .then((response) => response.data)
            .catch(this.handleError);
    }

    post(path: string, data: any) {
        return axios
            .post(`${this.api}${path}`, data)
            .then((response) => response.data)
            .catch(this.handleError);
    }

    put(path: string, data: any = null) {
        return axios
            .put(`${this.api}${path}`, data)
            .then((response) => response.data)
            .catch(this.handleError);
    }

    delete(path: string) {
        return axios
            .delete(`${this.api}${path}`)
            .then((response) => response.data)
            .catch(this.handleError);
    }

    handleError(error: AxiosError) {
      if (error.response.status === 401 && window.location.pathname !== '/') {
        window.location.replace('/');
      }

      return error;
    }
}
